import { Grid, Box, Link } from "@mui/material";
import "./S1_DataUsage.scss";
import { RoutingURLs } from "../../../../config/RoutingURLs";
import { DataUsageInfoProvider } from "../../../dataUsageInfo";
import { pushTrackingEventsToGAAndFB } from "../../../../utils/commonFunctions/GaAndFb";
import EnvConfig from "../../../../config/env.config.json";
import {
  gaCategory,
  gaEventTypes,
  gaScreenNames,
} from "../../../../Types/GoogleAnalytics";

interface IDataUsage {
  content: any;
  isCardExpired?: any;
}
const GAAndFBEventsHandler = (category: string, value: string) => {
  pushTrackingEventsToGAAndFB(gaEventTypes.event, gaEventTypes.click, {
    appName: EnvConfig.brand,
    screenName: gaScreenNames.signup,
    category: category,
    buttonValue: value,
  });
};
const DataUsage = ({ content, isCardExpired }: IDataUsage) => {
  return (
    <Grid
      display={"flex"}
      direction={"column"}
      alignItems={"center"}
      padding={"20px"}
      sx={{
        p: {
          xs: "calc(var(--mobile_section_padding)/2) 0 calc(var(--mobile_section_padding)/2)",
          sm: "calc(var(--ipad_section_padding)/2) 0 calc(var(--ipad_section_padding)/2)",
          md: "calc(var(--desktop_section_padding)/2) 0 calc(var(--desktop_section_padding)/2)",
        },
      }}
    >
      <DataUsageInfoProvider
        content={content}
        isCardExpired={isCardExpired}
        showSecondaryLinesUsage={false}
        showDataUsageForUnlimitedPack={true}
      />
      <Box mt="12px">
        <Link
          color={"var(--primary_color)"}
          underline="none"
          href={RoutingURLs.account}
          fontSize={"1rem"}
          fontWeight={"bold"}
          onClick={() =>
            GAAndFBEventsHandler(gaCategory.dataUsage, content?.view_details)
          }
        >
          {content?.view_details}
        </Link>
      </Box>
    </Grid>
  );
};

export default DataUsage;
